/**
 * @author NikolaV
 */

// pure
import { Events } from '@shared/Events';
import { getStationLineDirectionArrow, latLonToEN } from './ol-utils';
import { MapCoordsService } from '@openlayers/MapCoordsService';

// ol
import VectorLayer from 'ol/layer/Vector';
import Feature from 'ol/Feature';
import { LineString } from 'ol/geom';
import { transform as olTransform } from 'ol/proj';
import * as olStyle from 'ol/style';
import VectorSource from 'ol/source/Vector';
import { makeObservable, observable } from 'mobx';

// dirty todo
// uses jquery and updates dom

export class MapStationLayer {
    @observable markerLatLon: [number, number] = null;

    constructor() {
        makeObservable(this);
    }

    layer: VectorLayer<any> = new VectorLayer({
        source: new VectorSource()
    });

    style = new olStyle.Style({
        stroke: new olStyle.Stroke({
            color: 'black',
            width: 2
        }),

        fill: new olStyle.Fill({
            color: [150, 150, 255, 1]
        })
    });

    removeStationLine() {
        const existingLine = this.layer.getSource().getFeatureById('station_line');
        if (existingLine) this.layer.getSource().removeFeature(existingLine);
        this.clearStationInfo();
        Events.trigger('mapStationRemoved');
    }

    fetchAndDrawStationLine = _.debounce((e: number, n: number, alignmentId: number, alignmentIndex: number = 0) => {
        this.removeStationLine();

        if (!$.isNumeric(e) || !$.isNumeric(n)) {
            console.warn('[ map ] station line - bad coordinates');
            return false;
        }

        if (!alignmentId) {
            return;
        }

        const [lon, lat] = olTransform([e, n], 'EPSG:3857', 'EPSG:4326');
        this.markerLatLon = [lat, lon];

        MapCoordsService.fetchStationCoords(lat, lon, alignmentId, alignmentIndex)
            .done(resp => this.drawStationLine(resp.station));
    }, 100);

    drawStationLine(measure: StationCoords) {
        const a = measure.hasOwnProperty('a') ? measure.a.toFixed(1) : 0;
        const b = measure.hasOwnProperty('b') ? measure.b.toFixed(1) : null;
        const station = measure.station.toFixed(1);

        this.removeStationLine();

        // draw station line
        const p1 = latLonToEN(measure.lat, measure.lon);
        const p2 = latLonToEN(measure.lat2, measure.lon2);
        if (!p1 || !p2) {
            console.warn('Station line coords invalid, measure: ', measure);
            return;
        }

        const lineString = getStationLineDirectionArrow(p1, p2);

        lineString.push(p1);
        lineString.push(p2);

        const feature = new Feature({
            geometry: new LineString(lineString)
        });
        feature.setId('station_line');
        feature.setStyle(this.style);

        this.layer.getSource().addFeature(feature);
        Events.trigger('mapStationAdded', { measure, feature });
    }

    private clearStationInfo = () => {
        $('#paalu').html(kuura.getMessage('tablet.station_js') + ': <strong></strong>');
        $('#b-mitta').html(kuura.getMessage('tablet.sidemeasure_js') + ': <strong></strong>');
        $('#a-mitta').html('a: ');
    }
}
